import { render } from "./ModalMonitor.vue?vue&type=template&id=b57ca906&scoped=true"
import script from "./ModalMonitor.vue?vue&type=script&lang=js"
export * from "./ModalMonitor.vue?vue&type=script&lang=js"

import "./ModalMonitor.vue?vue&type=style&index=0&id=b57ca906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57ca906"]])

export default __exports__